export default "__VITE_ASSET__Kthqqa_e__"